// extracted by mini-css-extract-plugin
module.exports = {"imageBlock":"ImageBlock_imageBlock__2JDV5","image":"ImageBlock_image__3vCz5","deleteBtn":"ImageBlock_deleteBtn__1hCrL"};